export default __webpack_public_path__ + "static/media/light.e07413b7.svg";